<template>
  <div class="pagination">
    <ul>
      <!-- 이전버튼 -->
      <li><a class="btn-prev" @click="prevBlock"></a></li>
      <!-- 숫자버튼 -->
      <li
        v-for="item in pageList"
        :key="item"
        :class="{ now: modelValue === item }"
      >
        <a @click="changePage(item)" :class="{ now: modelValue === item }">{{
          item
        }}</a>
      </li>
      <!-- 다음버튼 -->
      <li><a class="btn-next" @click="nextBlock"></a></li>
    </ul>
  </div>
</template>

<script>
import { computed, getCurrentInstance } from 'vue'

export default {
  name: 'BasePagination',
  description: 'BasePagination',
  emits: ['update:modelValue', 'change'],
  props: {
    pageInfo: {
      type: Object
    },
    modelValue: {
      type: Number,
      default: 1
    }
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance()

    const pageList = computed(() => {
      return proxy.$_.range(
        props.pageInfo.startPage,
        props.pageInfo.endPage + 1
      )
    })

    const changePage = (item) => {
      emit('update:modelValue', item)
      emit('change', item)
    }

    const prevBlock = () => {
      if (props.pageInfo.isPrevBlock) {
        changePage(
          props.pageInfo.pagePerBlock * (props.pageInfo.pageBlock - 1)
        )
      } else {
        changePage(1)
      }
    }

    const nextBlock = () => {
      if (props.pageInfo.isNextBlock) {
        changePage(props.pageInfo.pagePerBlock * props.pageInfo.pageBlock + 1)
      } else {
        changePage(props.pageInfo.endPage)
      }
    }

    return {
      pageList,
      changePage,
      prevBlock,
      nextBlock
    }
  }
}
</script>

<style scoped>
a:hover {
  cursor: pointer;
}
</style>
